<template>
  <div class="editor-title">
    <h4>{{ t("message.caption") }}</h4>
  </div>
  <ul>
    <li class="editor-element">
      <!-- <input type="checkbox" name="" id="" checked />
      <i class="arrow"></i> -->
      <h2 class="text-start">{{ t("message.content") }}</h2>
      <div class="content-expand row">
        <div class="col-7 offset-5">
          <textarea
            name=""
            cols="30"
            rows="1"
            class="form-control"
            type="text"
            id="btnT"
            placeholder="Text"
            :value="textField"
            @input="updateContent($event)"
          ></textarea>
        </div>
      </div>
    </li>
    <li class="editor-element">
      <!-- <input type="checkbox" checked />
      <i class="arrow"></i> -->
      <h2 class="text-start">{{ t("message.formatting") }}</h2>
      <div class="content-expand row">
        <div class="col-7 offset-5 mb-2">
          <select
            name="font"
            id="font-select"
            class="form-select"
            @change="updateBtn('font-family', $event)"
          >
            <option value="Arial" style="font-family: Arial">Arial</option>
            <option
              value="BernhardFashion BT"
              style="font-family: BernhardFashion BT"
            >
              BernhardFashion BT
            </option>
            <option value="Calibri" style="font-family: Calibri">
              Calibri
            </option>
            <option value="Comic Sans MS" style="font-family: Comic Sans MS">
              Comic Sans MS
            </option>
            <option value="FuturaBlack BT" style="font-family: FuturaBlack BT">
              FuturaBlack BT
            </option>
            <option value="Gabriola" style="font-family: Gabriola">
              Gabriola
            </option>
            <option value="Lithograph" style="font-family: Lithograph">
              Lithograph
            </option>
            <option value="Segoe Script" style="font-family: Segoe Script">
              Segoe Script
            </option>
            <option value="Tahoma" style="font-family: Tahoma">Tahoma</option>
            <option
              value="Times New Roman"
              style="font-family: Times New Roman"
            >
              Times New Roman
            </option>
            <option value="TypoUpright BT" style="font-family: TypoUpright BT">
              TypoUpright BT
            </option>
            <option value="Verdana" style="font-family: Verdana">
              Verdana
            </option>
          </select>
        </div>
        <div class="col-7 offset-5 mb-2">
          <div class="row align-items-center">
            <div class="col-6">
              <select
                name="font-size"
                id="font-size"
                class="form-select"
                @change="updateBtn('font-size', $event)"
              >
                <option value="8px">8</option>
                <option value="10px">10</option>
                <option value="12px">12</option>
                <option value="14px">14</option>
                <option value="16px" selected>16</option>
                <option value="18px">18</option>
                <option value="24px">24</option>
                <option value="36px">36</option>
                <option value="48px">48</option>
                <option value="60px">60</option>
                <option value="72px">72</option>
                <option value="84px">84</option>
                <option value="96px">96</option>
                <option value="108px">108</option>
                <option value="120px">120</option>
              </select>
            </div>
            <div
              @click="updateBtn('font-weight', 'bold')"
              class="text-decoration"
            >
              <font-awesome-icon
                :icon="['fas', 'bold']"
                class="icon"
                size="lg"
              ></font-awesome-icon>
            </div>
            <div
              @click="updateBtn('font-style', 'italic')"
              class="text-decoration"
            >
              <font-awesome-icon
                :icon="['fas', 'italic']"
                class="icon"
                size="lg"
              ></font-awesome-icon>
            </div>
            <div
              @click="updateBtn('text-decoration', 'underline')"
              class="text-decoration"
            >
              <font-awesome-icon
                :icon="['fas', 'underline']"
                class="icon"
                size="lg"
              ></font-awesome-icon>
            </div>
          </div>
        </div>
        <h2 class="col-5 text-start">{{ t("message.color") }}</h2>
        <div class="col-7 text-start">
          <transition name="fade">
            <button
              class="btn btn-outline-lcn"
              v-if="!showPicker"
              @click="showPicker = true"
            >
              <font-awesome-icon
                :icon="['far', 'eye']"
                class="icon"
              ></font-awesome-icon>
              {{ t("message.fadeIn") }}
            </button>
          </transition>
        </div>
        <div class="content-expand">
          <transition name="fade">
            <div v-if="showPicker">
              <div class="color-picker-container">
                <MyCp
                  @update="changeColor"
                  @mouseup="mouseUp"
                  :id="'color-picker-inlaybg'"
                  :pColor="{
                    type: 'solid',
                    color:
                      selectedBtns.length > 0
                        ? inlayBtns[selectedBtns[0]].content.style.color
                        : '#0000000',
                  }"
                ></MyCp>
              </div>
              <div class="mt-3">
                <button class="btn btn-outline-lcn" @click="showPicker = false">
                  <font-awesome-icon
                    :icon="['far', 'eye-slash']"
                    class="icon"
                  ></font-awesome-icon>
                  {{ t("message.fadeOut") }}
                </button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </li>
    <li class="editor-element">
      <!-- <input type="checkbox" checked />
      <i class="arrow"></i> -->
      <h2 class="text-start row">
        <div class="col-5">{{ t("message.alignment") }}</div>
      </h2>
      <div class="content-expand">
        <div class="row">
          <div class="col-7 offset-5 text-start">
            <div
              class="d-inline-block pe-1 align"
              @click="updateBtn('justify-content', 'justify-content-start')"
            >
              <font-awesome-icon
                :icon="['fas', 'align-left']"
                class="icon"
                size="lg"
              ></font-awesome-icon>
            </div>
            <div
              class="d-inline-block pe-1 align"
              @click="updateBtn('justify-content', 'justify-content-center')"
            >
              <font-awesome-icon
                :icon="['fas', 'align-center']"
                class="icon"
                size="lg"
              ></font-awesome-icon>
            </div>
            <div
              class="d-inline-block pe-1 align"
              @click="updateBtn('justify-content', 'justify-content-end')"
            >
              <font-awesome-icon
                :icon="['fas', 'align-right']"
                class="icon"
                size="lg"
              ></font-awesome-icon>
            </div>
            <div
              class="d-inline-block pe-1 align"
              @click="updateBtn('align-items', 'align-items-start')"
            >
              <b-icon-align-top></b-icon-align-top>
            </div>
            <div
              class="d-inline-block pe-1 align"
              @click="updateBtn('align-items', 'align-items-center')"
            >
              <b-icon-align-middle></b-icon-align-middle>
            </div>
            <div
              class="d-inline-block pe-1 align"
              @click="updateBtn('align-items', 'align-items-end')"
            >
              <b-icon-align-bottom></b-icon-align-bottom>
            </div>
          </div>
        </div>
      </div>
    </li>
    <li class="editor-element">
      <!-- <input type="checkbox" checked />
      <i class="arrow"></i> -->
      <h2 class="text-start">{{ t("message.caption") }}</h2>
      <div class="content-expand row">
        <div class="col-7 offset-5 text-start">
          <button
            class="btn btn-outline-lcn"
            @click="displayBtn(), (showCaption = false)"
            v-if="showCaption"
          >
            <font-awesome-icon
              :icon="['far', 'eye-slash']"
              class="icon"
            ></font-awesome-icon>
            {{ t("message.fadeOut") }}
          </button>
          <button
            class="btn btn-outline-lcn"
            @click="displayBtn(), (showCaption = true)"
            v-if="!showCaption"
          >
            <font-awesome-icon
              :icon="['far', 'eye']"
              class="icon"
            ></font-awesome-icon>
            {{ t("message.fadeIn") }}
          </button>
        </div>
      </div>
    </li>
    <template v-if="!currentInlay.name.includes('gt6l')">
      <li class="topic-separator" v-if="currentInlay.inlay.bargraph.length > 0">
        <h2 class="text-start">{{ t("message.caption") }} Bargraph</h2>
        <div class="content-expand row">
          <div class="col-7 offset-5 text-start">
            <button class="btn btn-outline-lcn" @click="displayBarGCaption()">
              <font-awesome-icon
                :icon="['far', 'eye']"
                class="icon"
              ></font-awesome-icon>
              {{
                currentInlay.inlay.showBargraphCaptions
                  ? t("message.fadeOut")
                  : t("message.fadeIn")
              }}
            </button>
            <template
              v-if="
                currentInlay.inlay.showBargraphCaptions &&
                currentInlay.inlay.bargraphCaptionsAlternating
              "
            >
              <button
                class="btn btn-outline-lcn"
                @click="displayBarGCaptionLeftUp()"
              >
                {{
                  currentInlay.inlay.style.horizontal
                    ? t("message.bargraphCUp")
                    : t("message.bargraphCLeft")
                }}
              </button>
              <button
                class="btn btn-outline-lcn m-3"
                @click="displayBarGCaptionRightDown()"
              >
                {{
                  currentInlay.inlay.style.horizontal
                    ? t("message.bargraphCDown")
                    : t("message.bargraphCRight")
                }}
              </button>
            </template>
            <template
              v-if="
                !currentInlay.inlay.bargraphCaptionsAlternating &&
                currentInlay.inlay.showBargraphCaptions
              "
            >
              <button
                class="btn btn-outline-lcn mt-3 mb-3"
                @click="displayBarGCaptionAlternating()"
              >
                {{ t("message.bargraphCAlternating") }}
              </button>
            </template>
            <div class="row" v-if="currentInlay.inlay.showBargraphCaptions">
              <div class="col-11 text-start">
                Beschriftung-{{ t("message.color") }}
              </div>
              <div class="row justify-content-center">
                <div
                  class="col-1 swatch-el"
                  v-for="(color, index) in swatchColors"
                  :key="'color_' + index"
                  :style="{ 'background-color': color }"
                  @click="switchBarGCaptionColor(color)"
                ></div>
                <div
                  class="col-1 swatch-el"
                  @click="switchBarGCaptionColor('#ffffff')"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </template>
    <li class="topic-separator">
      <h2 class="text-start row">
        <div class="">{{ t("message.additionalText") }}</div>
      </h2>
      <div class="content-expand row text-start">
        <div class="col-7 offset-5 mb-2 t">
          <div class="align d-inline-flex me-2">
            <button class="btn btn-outline-lcn" @click="addText()">
              <font-awesome-icon
                :icon="['fas', 'plus']"
                class="icon"
              ></font-awesome-icon>
              {{ t("message.add") }}
            </button>
          </div>
        </div>

        <div class="col-7 offset-5 mb-2">
          <div class="align d-inline me-2" v-if="moveTexts">
            <button class="btn btn-outline-lcn mb-2" @click="editTexts(true)">
              <font-awesome-icon
                :icon="['far', 'edit']"
                class="icon"
              ></font-awesome-icon>
              {{ t("message.edit") }}
            </button>
          </div>
          <div class="align d-inline" v-if="!moveTexts">
            <button class="btn btn-outline-lcn" @click="editTexts(false)">
              <font-awesome-icon
                :icon="['fas', 'arrows-alt']"
                class="icon"
              ></font-awesome-icon>
              {{ t("message.move") }}
            </button>
          </div>
        </div>
      </div>

      <h2 class="row text-start">
        <div class="col-5">{{ t("message.angle") }}</div>
        <div class="col-4">
          <input class="form-control" type="number" @input="changeAngle" />
        </div>
      </h2>
    </li>
  </ul>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import MyCp from "@/views/editors/editor-components/ColorPicker.vue";
export default {
  components: {
    MyCp,
  },
  setup() {
    const store = useStore();
    const selectedBtns = computed(() => store.getters.selectedButtons);
    const inlayBtns = computed(() => store.getters.currentInlayBtns);
    const selectedTexts = computed(() => store.getters.selectedTexts);
    const showBarGCaptions = computed(() => store.getters.showBargraphCaptions);
    const moveTexts = computed(() => store.getters.moveTexts);
    const currentInlayBarG = computed(() => store.getters.currentInlayBarG);
    const showCaption = ref(true);
    const { t } = useI18n();
    const showPicker = ref(false);
    const swatchColors = [
      "#ff0000",
      "#E75F6B",
      "#e91e63",
      "#A46422",
      "#ff9800",
      "#ffff00",
      "#4CAF50",
      "#8bc34a",
      "#87ceeb",
      "#0000ff",
      "#a22cff",
      "#f1f1f1",
      "#000000",
    ];
    function changeColor(e) {
      updateBtn("color", e.colors.hex);
    }
    //update Button funktion für Text stylings
    function updateBtn(trigger, event) {
      //turn parameter into unified value for simplicity
      let value = event;
      //TODO: double check that correct value is being simplified - Doch noch umändern?
      if (typeof event == "object") {
        value = event.target.value;
      }
      // if (selectedBtns.value.length < 1) return alert("Please select a Button");
      for (let btn in selectedBtns.value) {
        // check if trigger is one of the switchable values and if said value should be nulled
        if (
          (trigger == "font-weight" ||
            trigger == "font-style" ||
            trigger == "text-decoration") &&
          inlayBtns.value[selectedBtns.value[btn]].content.style[trigger] ==
            value
        ) {
          inlayBtns.value[selectedBtns.value[btn]].content.style[trigger] = "";
          //otherwise just assign
        } else {
          inlayBtns.value[selectedBtns.value[btn]].content.style[trigger] =
            value;
        }
      }
      if (!moveTexts.value) {
        //same procedure as above for the selected additional Texts
        for (let text in selectedTexts.value) {
          if (
            (trigger == "font-weight" ||
              trigger == "font-style" ||
              trigger == "text-decoration") &&
            draggableTexts.value[selectedTexts.value[text]].style[trigger] ==
              value
          ) {
            draggableTexts.value[selectedTexts.value[text]].style[trigger] = "";
            //otherwise just assign
          } else {
            draggableTexts.value[selectedTexts.value[text]].style[trigger] =
              value;
          }
        }
      }

      store.dispatch("saveInlay");
    }
    function updateContent(event) {
      for (let btn in selectedBtns.value) {
        inlayBtns.value[selectedBtns.value[btn]].content.content =
          event.target.value;
      }
      for (let text in selectedTexts.value) {
        draggableTexts.value[selectedTexts.value[text]].content =
          event.target.value;
      }
      store.dispatch("saveInlay");
    }
    //Funktion zum Anzeigen der Buttons
    function displayBtn() {
      //Für jeden ausgewählten Button den Text anzeigen oder nicht
      for (let btn in inlayBtns.value) {
        inlayBtns.value[btn].content["d-content"] =
          !inlayBtns.value[btn].content["d-content"];
      }

      store.dispatch("saveInlay");
    }
    //Funktion zum hinzufügen von weiteren editierbaren Textelementen
    function addText() {
      store.dispatch("addText");
      store.dispatch("saveInlay");
    }
    const currentInlay = computed(() => store.getters.currentInlay);
    function displayBarGCaption() {
      store.dispatch("toggleBarGCaptions", !showBarGCaptions.value);
    }

    const draggableTexts = computed(() => store.getters.draggableTexts);
    function editTexts(value) {
      draggableTexts.value.forEach((text) => {
        text.editable = value;
      });
      if (!value) store.commit("setSelectedText");
      store.commit("setMoveTexts", !value);
    }
    function changeAngle(event) {
      if (!moveTexts.value) {
        for (let text in selectedTexts.value) {
          draggableTexts.value[selectedTexts.value[text]].style.transform =
            "rotate(" + event.target.value + "deg)";
        }
      }
    }
    const textField = computed(() => {
      let content = "Text";
      if (selectedBtns.value.length > 0)
        content = inlayBtns.value[selectedBtns.value[0]].content.content;
      else if (selectedTexts.value.length > 0)
        content = draggableTexts.value[selectedTexts.value[0]].content;
      return content;
    });
    function displayBarGCaptionLeftUp() {
      store.commit("setBarGCaptionsLeftUp");
    }
    function displayBarGCaptionRightDown() {
      store.commit("setBarGCaptionsRightDown");
    }
    function displayBarGCaptionAlternating() {
      store.commit("setBarGCaptionsAlternating");
    }
    function switchBarGCaptionColor(color) {
      store.commit("setBarGCaptionColor", color);
      store.dispatch("saveInlay");
    }
    return {
      updateBtn,
      updateContent,
      displayBtn,
      addText,
      currentInlay,
      displayBarGCaption,
      showCaption,
      t,
      editTexts,
      moveTexts,
      changeAngle,
      selectedBtns,
      inlayBtns,
      textField,
      showPicker,
      changeColor,
      displayBarGCaptionLeftUp,
      displayBarGCaptionRightDown,
      displayBarGCaptionAlternating,
      swatchColors,
      switchBarGCaptionColor,
    };
  },
};
</script>

<style lang="scss" scoped>
.align {
  cursor: pointer;
}
.text-decoration {
  width: 15%;
  padding: 5px;
  display: inline-flex;
  cursor: pointer;
}
.swatch-el,
.border-color {
  border: 1px solid grey;
  border-radius: 5px;
  height: 20px;
  width: 20px;
  margin: 3px;
  // margin-left: 15px;
  cursor: pointer;
}
</style>
